import { getMyGameLanguage } from 'core/utils/i18n'

interface DateProps {
  value?: string | null
  fallback?: string
}

const formatDate = (value: string | null | undefined, fallback = '--') => {
  if (value == null) return fallback

  try {
    const dateObject = new Date(value + 'T00:00:00Z')
    return new Intl.DateTimeFormat(getMyGameLanguage(), { timeZone: 'UTC' }).format(dateObject)
  } catch {
    return value
  }
}

export const MgDate = ({ value, fallback }: DateProps) => <span className="date">{formatDate(value, fallback)}</span>

export default MgDate
